import { useEffect, useState } from "react";
import DashboardApi from "../../../../../api/DashboardApi";
import { AlarmEventOverviewWrapper, AlarmEventTotalWrapper, AlarmEventTodayWrapper, AlarmEventUnackedWrapper, Icon,TextWrapper, Text } from "./AlarmEventOverview.styled";
import { BellTwoTone, BookTwoTone, CreditCardTwoTone } from "@ant-design/icons";

interface AlarmEventOverviewProps {

}


const AlarmEventOverview : React.FC<AlarmEventOverviewProps> = (props) => {
    
     // api
    let dashboardApi = new DashboardApi();
   
    // state
    let [alarmEventTotal, setAlarmEventTotal] = useState(0);
    let [alarmEventToday, setAlarmEventToday] = useState(0);
    let [alarmEventUnacked, setAlarmEventUnacked] = useState(0);

 
    // onload
    useEffect(()=> {
        let loadSystemOverview = async ()=> {
            let systemRealtimeOverview = (await dashboardApi.getSystemRealtimeOverview()).data.data;
            setAlarmEventTotal(systemRealtimeOverview.alarmEventsOverview.total);
            setAlarmEventToday(systemRealtimeOverview.alarmEventsOverview.today);
            setAlarmEventUnacked(systemRealtimeOverview.alarmEventsOverview.unacked);
        };

        loadSystemOverview();

        let refreshTask = setInterval(()=> {
            loadSystemOverview();
        }, 5000);

        return () => {
            clearInterval(refreshTask);
        }
    }, []);

    return (
        <AlarmEventOverviewWrapper>
            <AlarmEventTotalWrapper>
                <Icon> <CreditCardTwoTone  twoToneColor={['#b9b6b6', '#ecdaa8a6']} /></Icon>
                <TextWrapper>
                    <Text>总告警数 </Text>
                    <Text>{alarmEventTotal}</Text>
                </TextWrapper>
            </AlarmEventTotalWrapper>
            <AlarmEventTodayWrapper>
                <Icon> <BellTwoTone twoToneColor={['#79918d85', '#88e2f84b']} /></Icon>
                <TextWrapper>
                    <Text>今日新增 </Text>
                    <Text>{alarmEventToday}</Text>
                </TextWrapper>
            </AlarmEventTodayWrapper>
            <AlarmEventUnackedWrapper>
                <Icon> <BookTwoTone twoToneColor={['#79918d85', '#5fa8864b']}/></Icon>
                <TextWrapper>
                    <Text>未处理 </Text>
                    <Text>{alarmEventUnacked}</Text>
                </TextWrapper>
            </AlarmEventUnackedWrapper>
        </AlarmEventOverviewWrapper>
    );
}

export default AlarmEventOverview;